import * as Comp from "..";
import { is, List } from "immutable";
import * as React from "react";
import { connect } from "react-redux";
import * as redux from "redux";
import * as AdminEventActions from "../../actions/AdminEventActions";
import { SubEvent } from "../../models/event";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    events: state.adminEvents.subEvents,
    loading: state.adminEvents.loadingSubEvents,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadData: (eventId: number) => dispatch(AdminEventActions.loadSubEvents(eventId)),
    toggleLoading: (loading: boolean) => dispatch(AdminEventActions.toggleLoadingSubEvents(loading)),
});

interface OwnProps {
    eventId: number;
    onUpdated: (loading: boolean, events: List<SubEvent>) => void;
}

type ConnectedState = Comp.Base.DefaultConnectedState & {
    events: List<SubEvent>;
    loading: boolean;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadData: (eventId: number) => void;
    toggleLoading: (loading: boolean) => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class LoaderComponent extends React.Component<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {
        if (this.props.events.size)
            this.props.onUpdated(false, this.subEventsForEvent());
        else {
            this.props.loadData(this.props.eventId);
            this.props.toggleLoading(true);
        }
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        if (!is(prevProps.events, this.props.events))
            this.props.onUpdated(this.props.loading, this.subEventsForEvent());
        if (prevProps.loading !== this.props.loading)
            this.props.onUpdated(this.props.loading, this.subEventsForEvent());
    }

    public render() {
        return null;
    }

    private subEventsForEvent() {
        return this.props.events
        .filter((x) => x !== undefined && x.parentId === this.props.eventId)
        .toList();
    }
}

export const AdminSubEventsLoader: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(LoaderComponent);



// WEBPACK FOOTER //
// ./src/components/reusable/AdminSubEventsLoader.tsx